module.exports = __webpack_public_path__ + "static/media/quality-assurance.5effbd49.jpg";